import { z } from "zod";
const count = z
  .object({ lower: z.number().int().min(20), upper: z.number().int().min(29) })
  .refine((v) => v.lower % 10 === 0 && v.upper === v.lower + 9);
const bucket = z.object({
  label: z.string().max(100),
  lower: z.number().int().min(20),
  upper: z.number().int().min(29),
});
export const observatorySchema = z.object({
  contract: z.literal("community-observatory-v1"),
  minimum_tickets: z.number().int().min(20),
  complete_before: z.string().regex(/^20\d{2}-(0[1-9]|1[0-2])$/),
  countries: z.record(z.string(), z.string()),
  provinces: z.record(z.string(), z.string()),
  reviewed_cross_border: z.literal("not_collected"),
  views: z.array(
    z.object({
      location: z.string(),
      community: z.string(),
      platform: z.string(),
      threat: z.string(),
      cases: count,
      dimensions: z.record(z.string(), z.array(bucket)),
      matrix: z.array(
        z.object({
          community: z.string(),
          threat: z.string(),
          lower: z.number(),
          upper: z.number(),
        }),
      ),
      series: z.array(
        z.object({
          month: z.string(),
          threat: z.string(),
          lower: z.number(),
          upper: z.number(),
        }),
      ),
    }),
  ),
});
export type Observatory = z.infer<typeof observatorySchema>;
export type ObservatoryView = Observatory["views"][number];
export type CountRange = { lower: number; upper: number };
